import type { GetOptions, MercuryBalanceSnapshot } from "@/core";
import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { useQuery } from "@tanstack/react-query";

const databaseService = serviceHost.getDatabaseService();
const mercuryBalanceSnapshotRepository =
  repositoryHost.getMercuryBalanceSnapshotRepository(databaseService);
const functionsService = serviceHost.getFunctionsService();

/** Live balances of our Mercury accounts (fetched from Mercury on demand). */
export const useMercuryBalances = () =>
  useQuery({
    queryKey: ["mercury-balances", "live"],
    queryFn: () => functionsService.getMercuryBalances(),
    staleTime: 60_000,
  });

/** Stored daily balance snapshots in a date range, ascending by date. */
export const useMercuryBalanceSnapshots = (range: {
  startDate: string; // "YYYY-MM-DD"
  endDate: string; // "YYYY-MM-DD"
}) =>
  useQuery({
    queryKey: ["mercury-balance-snapshots", range.startDate, range.endDate],
    queryFn: () =>
      mercuryBalanceSnapshotRepository.getAll({
        queryConstraints: [
          { field: "date", operator: ">=", value: range.startDate },
          { field: "date", operator: "<=", value: range.endDate },
        ],
        orderBy: { field: "date", direction: "asc" },
        pagination: { limit: 1000 },
      } as GetOptions<MercuryBalanceSnapshot>),
    enabled: !!range.startDate && !!range.endDate,
  });
